import { UseCase } from '@/shared/application/UseCase';
import { EnrollmentRepository } from '@/application/shared/domain/EnrollmentRepository';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import { SfApiResponse } from '@hfc/ui-core';

export class SaveAndExitUseCase implements UseCase<[APPLICATION_TYPES, string, unknown, string], SfApiResponse> {

  private repository: EnrollmentRepository;

  public constructor (repository: EnrollmentRepository) {
    this.repository = repository;
  }

  public async run (params: [APPLICATION_TYPES, string, unknown, string]): Promise<SfApiResponse> {
    const [applicationType, email, application, uuid] = params;

    return await this.repository.saveAndExit(applicationType, email, application, uuid);
  }

}
